import { createTheme } from '@mui/material/styles';

// Theme aligned to the "core" dashboard look (light surface, subtle borders/shadows).
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2e5bff',
      dark: '#2447cc',
      light: '#6b8cff'
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff'
    },
    text: {
      primary: '#0f172a',
      secondary: '#64748b'
    },
    divider: '#e2e8f0'
  },
  typography: {
    fontFamily: [
      'Inter',
      'Roboto',
      'Segoe UI',
      'Arial',
      'sans-serif'
    ].join(','),
    h6: { fontWeight: 600 }
  },
  shape: {
    borderRadius: 12
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: '#f8fafc' }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          borderRadius: 10
        },
        contained: {
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid #e2e8f0',
          boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
          borderRadius: 14
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderColor: '#e2e8f0'
        }
      }
    }
  }
});

export default theme;

